<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Inventory Ticket
        <small>List of Inventory Ticket</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i>Home</a></li>
        <li class="active">Inventory Ticket</li>
      </ol>
    </section>
    
    <section class="content">
      <div class="button-flagging">
        <a v-if="params.flaging === 'explore'" 
          class="btn active-flag magin-right disabled"
          disabled>
          Explore Inventory
        </a>
        <a v-else class="btn btn-primary magin-right"
          @click.prevent="changeFlag()">
          Explore Inventory
        </a>
        <a v-if="params.flaging === 'tour'" 
          class="btn active-flag disabled"
          disabled>
          Tour Inventory
        </a>
        <a v-else class="btn btn-primary"
          @click.prevent="changeFlag()">
          Tour Inventory
        </a>
      </div>

      <div class="box">
        <div class="box-header with-border">
          <strong>Filter Inventory</strong>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: inherit">
          <div class="form-group">
            <label for="promoPaymentName">
              Name
            </label>

            <input type="text"
              class="form-control"
              id="inventoryName"
              placeholder="Search by name here"
              v-model="params.name"
              @keyup="onInput">
          </div>
        </div>
      </div>

      <span v-if="params.flaging === 'explore'">Explore Inventory</span>
      <span v-else >Tour Inventory</span>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New inventory
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th v-if="params.flaging === 'explore'" >Explore Name</th>
                <th v-else >Tour Name</th>
                <th>Stock All</th>
                <th>Stock Available</th>
                <th>Stock Booked</th>
                <th>Stock Sold</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody v-if="isLoading" key="loading">
              <tr>
                <td colspan="6">
                  <strong>Loading</strong>
                </td>
              </tr>
            </tbody>

            <tbody v-else-if="!isLoading && items.length < 1" key="empty">
              <tr>
                <td colspan="6">
                  <strong>Result not found</strong>
                </td>
              </tr>
            </tbody>

            <tbody v-else key="data">
              <tr v-for="item in items">
                <td>{{ item.name }}</td>
                <td>{{ item.stock_all }}</td>
                <td>{{ item.stock_available }}</td>
                <td>{{ item.stock_booked }}</td>
                <td>{{ item.stock_sold }}</td>
                <td>
                  <a class="btn btn-primary btn-xs"
                    @click.prevent="edit(item.id)">
                    Edit
                  </a>
                  <a class="btn btn-success btn-xs"
                    @click.prevent="view(item.id)">
                    Details
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'InventoryIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      isLoading: true,
      isInitial: true,
      items: [],
      pagination: {},
      params: {
        flaging: null,
        name: null,
        page: null,
      },
    };
  },

  methods: {
    async init() {
      await this.setQuery();
      await this.fetch();
      if (!this.params.flaging) {
        this.params.flaging = 'explore';
      }
      this.isInitial = false;
    },

    fetch(page = null) {
      this.isLoading = true;
      if (page) this.params.page = page || null;

      const getParams = {
        type_product: this.params.flaging,
        name: this.params.name,
        page: this.params.page,
      };

      this.axios.get('/tickets', { params: getParams })
        .then((response) => {
          const { data, meta } = response.data;

          const isEmpty = (!data && (meta.pagination.current_page > meta.pagination.total_pages));
          this.items = (!isEmpty) ? data : [];
          this.pagination = (!isEmpty) ? meta.pagination : {};
          this.isLoading = false;
          this.setPushState();
        });
    },

    onInput: debounce(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    setQuery() {
      return new Promise((resolve) => {
        this.params.flaging = this.$route.query.flaging || null;
        this.params.name = this.$route.query.name || null;
        this.params.page = this.$route.query.page || null;

        resolve();
      });
    },

    generateQuery(params) {
      if (!params) return null;

      const query = Object.keys(params)
        .filter(key => (params[key]))
        .map(key => `${key}=${this.params[key]}`);

      return (query) ? `?${query.join('&')}` : null;
    },

    setPushState() {
      const title = `Inventory page ${this.params.page}`;
      const paramUrl = '/inventory';
      const parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, `${paramUrl}${parameters}`);
    },

    changeFlag() {
      if (this.params.flaging === 'explore') {
        this.params.flaging = 'tour';
      } else {
        this.params.flaging = 'explore';
      }
      this.params.name = null;
      this.params.page = null;
      this.fetch();
    },

    changePage(page) {
      this.fetch(page);
    },


    add() {
      this.$router.push({
        name: 'inventory-create',
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },

    edit(id) {
      this.$router.push({
        name: 'inventory-edit',
        params: { id },
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },
    view(id) {
      this.$router.push({
        name: 'inventory-view',
        params: { id },
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },
  },

  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.magin-right{
  margin-right: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/inventory/Index.vue